import { render, staticRenderFns } from "./UserAccountProperty.vue?vue&type=template&id=0d941301&"
import script from "./UserAccountProperty.vue?vue&type=script&lang=ts&"
export * from "./UserAccountProperty.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports